import { motion } from "framer-motion";
import { ShieldCheck, HandshakeIcon, Award, Stethoscope } from "lucide-react";

const VALUES = [
  {
    icon: ShieldCheck,
    title: "Transparência",
    text: "Diagnóstico claro, orçamento honesto e processo documentado em cada etapa.",
  },
  {
    icon: HandshakeIcon,
    title: "Confiança",
    text: "Compromisso real com o cliente e com a segurança do seu veículo.",
  },
  {
    icon: Award,
    title: "Qualidade",
    text: "Peças, ferramentas e padrão de execução em nível premium.",
  },
  {
    icon: Stethoscope,
    title: "Diagnóstico Profissional",
    text: "Equipamentos modernos e leitura precisa para soluções definitivas.",
  },
];

export default function About() {
  return (
    <section
      id="sobre"
      data-testid="about-section"
      className="relative py-24 md:py-32 bg-carbon overflow-hidden"
    >
      <div className="absolute inset-0 bg-noise opacity-[0.03] pointer-events-none" />
      <div className="absolute -left-40 top-1/2 w-[400px] h-[400px] bg-red-600/10 blur-[120px] rounded-full" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          {/* Left: Heading + Text */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-5"
          >
            <p className="text-xs uppercase tracking-[0.35em] text-red-500 font-bold mb-6 flex items-center gap-3">
              <span className="w-8 h-px bg-red-500" />
              Sobre a Full Force
            </p>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-black uppercase leading-[1] tracking-tighter text-white">
              Oficina premium,<br />
              <span className="text-stroke">trabalho</span>{" "}
              <span className="text-red-600">honesto.</span>
            </h2>
            <div className="mt-8 space-y-5 text-zinc-400 text-base md:text-lg leading-relaxed font-body max-w-xl">
              <p>
                A <span className="text-white font-semibold">Full Force Car Premium</span> nasceu com um propósito simples: entregar serviços automotivos com qualidade, transparência e confiança, oferecendo uma experiência diferenciada em manutenção.
              </p>
              <p>
                Especializada em <span className="text-white">câmbio automático</span> e mecânica em geral, atuamos em Jundiaí/SP com foco em diagnóstico preciso, atendimento profissional e soluções seguras para cada veículo.
              </p>
            </div>

            <div className="mt-10 flex items-center gap-6">
              <div className="border-l-2 border-red-600 pl-4">
                <p className="font-display text-4xl font-black text-white">+10</p>
                <p className="text-xs uppercase tracking-widest text-zinc-500">anos de experiência</p>
              </div>
              <div className="border-l-2 border-red-600 pl-4">
                <p className="font-display text-4xl font-black text-white">100%</p>
                <p className="text-xs uppercase tracking-widest text-zinc-500">diagnóstico técnico</p>
              </div>
            </div>
          </motion.div>

          {/* Right: Value Cards Bento */}
          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-5">
            {VALUES.map((v, i) => (
              <motion.div
                key={v.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                data-testid={`about-card-${v.title.toLowerCase()}`}
                className={`group relative bg-zinc-900/40 backdrop-blur-md border border-zinc-800/80 p-7 hover:border-red-600/50 transition-all duration-300 ${
                  i === 0 || i === 3 ? "sm:translate-y-6" : ""
                }`}
              >
                <div className="absolute top-0 left-0 w-12 h-px bg-red-600 group-hover:w-full transition-all duration-500" />
                <v.icon
                  size={36}
                  strokeWidth={1.5}
                  className="text-red-500 mb-5 group-hover:scale-110 transition-transform duration-300"
                />
                <h3 className="font-display text-xl font-bold text-white uppercase tracking-tight mb-2">
                  {v.title}
                </h3>
                <p className="text-sm text-zinc-400 leading-relaxed">{v.text}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
